import { DateTime } from 'luxon'

export const criteriaGroup = (criteria) => {
  return {
    criteria: criteria,
    operator: 'AND',
  }
}

export const isInSegmentCriteria = (segment) => [
  { id: 2, value: 0 },
  { id: 3, value: 0 },
  { id: 0, value: 0 },
  {
    id: 0,
    value: {
      segment_data: segment.data,
      _id: segment._id,
      name: segment.name,
      updated_at: DateTime.now().toISO(),
    },
  },
]

export const isInUnitsCriteria = (units, startDate, endDate) => [
  [
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 2, value: 0 },
    { id: 0, value: units },
    { id: 0, value: 1 },
    { id: 1, value: [startDate, endDate] },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
  ],
]

export const isInUnitsCriteriaByProduct = (units, startDate, endDate, sku) => [
  { id: 0, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: 1 },
  { id: 1, value: 0 },
  { id: 0, value: [sku] },
  { id: 0, value: units },
  { id: 0, value: 1 },
  { id: 1, value: [startDate, endDate] },
  { id: 0, value: 0 },
  { id: 0, value: 0 },
]

export const listOfIdsCriteria = (ids, description) => [
  { id: 1, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: { values: ids, field: 'CODIGO', description } },
]

export const signupDateCriteria = (startDate, endDate) => [
  { id: 1, value: 0 },
  { id: 1, value: 0 },
  { id: 1, value: 0 },
  { id: 0, value: 1 },
  { id: 1, value: [startDate, endDate] },
]

export const anyPurchaseCriteria = (startDate, endDate) => [
  { id: 0, value: 0 },
  { id: 0, value: 0 },
  { id: 3, value: 0 },
  { id: 0, value: 2 },
  { id: 2, value: 0 },
  { id: 0, value: 1 },
  { id: 1, value: [startDate, endDate] },
  { id: 0, value: 0 },
  { id: 0, value: 0 },
]

export const notAnyPurchaseCriteria = (startDate, endDate) => [
  { id: 0, value: 0 },
  { id: 2, value: 0 },
  { id: 3, value: 0 },
  { id: 0, value: 2 },
  { id: 2, value: 0 },
  { id: 0, value: 1 },
  { id: 1, value: [startDate, endDate] },
  { id: 0, value: 0 },
  { id: 0, value: 0 },
]

export const isLoyalCriteria = (loyalty) => [{ id: 1 }, { id: 2 }, { id: 0 }, { id: 0, value: 0 }, { id: 0, value: loyalty ? '1' : '0' }]

export const personTypeCriteria = (personType) => [{ id: 1 }, { id: 3 }, { id: 0 }, { id: 0, value: 0 }, { id: 0, value: personType }]

export const ageRangeCriteria = (startAge, endAge) => [
  { id: 1, value: 0 },
  { id: 3, value: 0 },
  { id: 2, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: '1' },
  { id: 0, value: [startAge, endAge] },
]

export const noAgeRangeCriteria = () => [
  { id: 1, value: 0 },
  { id: 3, value: 0 },
  { id: 2, value: 0 },
  { id: 0, value: 1 },
  { id: 1, value: '0' },
]

export const genderCriteria = (gender) => [{ id: 1 }, { id: 3 }, { id: 1 }, { id: 0, value: 0 }, { id: 0, value: gender }]

export const neighborhoodsCriteria = (neighborhoodBranches) => [
  { id: 1, value: 0 },
  { id: 4, value: 0 },
  { id: 2, value: 0 },
  { id: 0, value: neighborhoodBranches },
]

export const citiesCriteria = (cityBranches) => [
  { id: 1, value: 0 },
  { id: 4, value: 0 },
  { id: 3, value: 0 },
  { id: 0, value: cityBranches },
]

const isActiveBeforeDate = (date) => {
  return [
    { id: 0, value: 0 },
    { id: 4, value: 0 },
    { id: 8, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: date },
  ]
}

const isInactiveBeforeDate = (date) => {
  return [
    { id: 0, value: 0 },
    { id: 4, value: 0 },
    { id: 8, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: 1 },
    { id: 1, value: date },
  ]
}

const isLostBeforeDate = (date) => {
  return [
    { id: 0, value: 0 },
    { id: 4, value: 0 },
    { id: 8, value: 0 },
    { id: 0, value: 3 },
    { id: 3, value: 1 },
    { id: 1, value: date },
  ]
}

const isNeverBoughtBeforeDate = (date) => {
  return [
    { id: 0, value: 0 },
    { id: 4, value: 0 },
    { id: 8, value: 0 },
    { id: 0, value: 4 },
    { id: 4, value: 0 },
    { id: 0, value: date },
  ]
}

const isAtRiskBeforeDate = (date) => {
  return [
    { id: 0, value: 0 },
    { id: 4, value: 0 },
    { id: 8, value: 0 },
    { id: 0, value: 2 },
    { id: 2, value: 1 },
    { id: 1, value: date },
  ]
}

export const campaignReceivedCriteria = (campaignIds, startDate = '', endDate = '', channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  let dateCriteriaNodes = []
  if (startDate && endDate) {
    dateCriteriaNodes = [
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ]
  } else {
    dateCriteriaNodes = [{ id: 0, value: 0 }]
  }
  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: '2' },
    { id: 0, value: campaignIds },
    { id: 0, value: channelsId },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    ...dateCriteriaNodes,
  ]
}

export const campaignReceivedAndPurchasedCriteria = (campaignIds, startDate = '', endDate = '', channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  let dateCriteriaNodes = []

  if (startDate && endDate) {
    dateCriteriaNodes = [
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ]
  } else {
    dateCriteriaNodes = [{ id: 0, value: 0 }]
  }

  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: '2' },
    { id: 0, value: campaignIds },
    { id: 0, value: channelsId },
    { id: 0, value: 1 },
    { id: 1, value: 0 },
    ...dateCriteriaNodes,
  ]
}

export const campaignReceivedAndPurchasedAnyCampaignPeriodCriteria = (campaignIds, channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: '2' },
    { id: 0, value: campaignIds },
    { id: 0, value: channelsId },
    { id: 0, value: 1 },
    { id: 1, value: 0 },
    { id: 0, value: 0 },
  ]
}

export const campaignReceivedAndPurchasedAnyProductCriteria = (campaignIds, startDate, endDate, channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  let dateCriteriaNodes = []
  if (startDate && endDate) {
    dateCriteriaNodes = [
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ]
  } else {
    dateCriteriaNodes = [{ id: 0, value: 0 }]
  }

  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: '2' },
    { id: 0, value: campaignIds },
    { id: 0, value: channelsId },
    { id: 0, value: 2 },
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    ...dateCriteriaNodes,
  ]
}

export const campaignReceivedAndOnlyPurchasedAnyProductCriteria = (
  campaignIds,
  startDate = '',
  endDate = '',
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  let dateCriteriaNodes = []
  if (startDate && endDate) {
    dateCriteriaNodes = [
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ]
  } else {
    dateCriteriaNodes = [{ id: 0, value: 0 }]
  }

  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: '2' },
    { id: 0, value: campaignIds },
    { id: 0, value: channelsId },
    { id: 0, value: 3 },
    { id: 3, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    ...dateCriteriaNodes,
  ]
}

export const campaignReceivedAndOnlyPurchasedAnyProductCriteriaMariaCampaign = (
  campaignIds,
  startDate,
  endDate,
  units = [],
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 3 },
      { id: 3, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const campaignOpenedAndPurchasedCriteria = (campaignIds) => [
  { id: 2, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: 1 },
  { id: 1, value: '3' },
  { id: 0, value: campaignIds },
  { id: 0, value: 1 },
  { id: 1, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: 0 },
]

export const campaignOpenedAndPurchasedAnyProductCriteria = (campaignIds, startDate, endDate) => {
  let dateCriteriaNodes = []
  if (startDate && endDate) {
    dateCriteriaNodes = [
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ]
  } else {
    dateCriteriaNodes = [{ id: 0, value: 0 }]
  }
  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: '3' },
    { id: 0, value: campaignIds },
    { id: 0, value: 2 },
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    ...dateCriteriaNodes,
  ]
}

export const campaignOpenedAndOnlyPurchasedAnyProductCriteria = (campaignIds, startDate, endDate) => {
  let dateCriteriaNodes = []
  if (startDate && endDate) {
    dateCriteriaNodes = [
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ]
  } else {
    dateCriteriaNodes = [{ id: 0, value: 0 }]
  }
  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: '3' },
    { id: 0, value: campaignIds },
    { id: 0, value: 3 },
    { id: 3, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    ...dateCriteriaNodes,
  ]
}

export const campaignReceivedAndPurchasedSpecificProductCriteria = (
  campaignIds,
  products,
  logicOperator = 'OR',
  startDate = undefined,
  endDate = undefined,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  let dateCriteriaNodes = []
  if (startDate && endDate) {
    dateCriteriaNodes = [
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ]
  } else {
    dateCriteriaNodes = [{ id: 0, value: 0 }]
  }
  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: '2' },
    { id: 0, value: campaignIds },
    { id: 0, value: channelsId },
    { id: 0, value: 2 },
    { id: 2, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: logicOperator === 'OR' ? 0 : 2 },
    { id: logicOperator === 'OR' ? 0 : 2, value: 0 },
    { id: 0, value: products },
    ...dateCriteriaNodes,
  ]
}

export const campaignOpenedAndPurchasedSpecificProductCriteria = (campaignIds, products, logicOperator = 'OR', startDate = undefined, endDate = undefined) => {
  let dateCriteriaNodes = []
  if (startDate && endDate) {
    dateCriteriaNodes = [
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ]
  } else {
    dateCriteriaNodes = [{ id: 0, value: 0 }]
  }
  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 1, value: '3' },
    { id: 0, value: campaignIds },
    { id: 0, value: 2 },
    { id: 2, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: logicOperator === 'OR' ? 0 : 2 },
    { id: logicOperator === 'OR' ? 0 : 2, value: 0 },
    { id: 0, value: products },
    ...dateCriteriaNodes,
  ]
}

export const willPurchaseProductsCriteria = (products, units, minAmount, startDate, endDate, logicOperator = 'OR') => [
  { id: 0, value: 0 },
  { id: 3, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: logicOperator === 'OR' ? 0 : 1 },
  { id: logicOperator === 'OR' ? 0 : 1, value: 0 },
  { id: 0, value: products },
  { id: 0, value: units },
  { id: 0, value: minAmount },
  { id: 0, value: 1 },
  { id: 1, value: [startDate, endDate] },
]

export const willBecomeInactiveCriteria = (units, minAmount, startDate, endDate) => [
  { id: 0, value: 0 },
  { id: 3, value: 0 },
  { id: 1, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: units },
  { id: 0, value: minAmount },
  { id: 0, value: 1 },
  { id: 1, value: [startDate, endDate] },
]

export const willPurchaseCriteria = (units, minAmount, startDate, endDate) => [
  { id: 0, value: 0 },
  { id: 3, value: 0 },
  { id: 2, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: units },
  { id: 0, value: minAmount },
  { id: 0, value: 1 },
  { id: 1, value: [startDate, endDate] },
]

export const totalClientsBelowAverageProductValue = (units, products, minAmount, startDate, endDate) => [
  { id: 0, value: 0 },
  { id: 4, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: units },
  { id: 0, value: products },
  { id: 0, value: minAmount },
  { id: 0, value: 1 },
  { id: 1, value: [startDate, endDate] },
]

export const totalClientsDecreasedAverageItemsInBasket = (units, products, referencyDate, currentDate) => [
  { id: 0, value: 0 },
  { id: 4, value: 0 },
  { id: 2, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: units },
  { id: 0, value: products },
  { id: 0, value: referencyDate },
  { id: 0, value: currentDate },
]

export const customerDidNotBoughtInPeriod = (units, products, currentDate) => {
  if (products?.length) {
    return [
      [
        { id: 0, value: 0 },
        { id: 2, value: 0 },
        { id: 0, value: 0 },
        { id: 0, value: 1 },
        { id: 1, value: 0 },
        { id: 0, value: products },
        { id: 0, value: units },
        { id: 0, value: 1 },
        { id: 1, value: currentDate },
        { id: 0, value: 0 },
        { id: 0, value: 0 },
      ],
      [
        { id: 0, value: 0 },
        { id: 0, value: 0 },
        { id: 0, value: 0 },
        { id: 0, value: 1 },
        { id: 1, value: 0 },
        { id: 0, value: products },
        { id: 0, value: units },
        { id: 0, value: 2 },
        { id: 2, value: 0 },
        { id: 0, value: 0 },
        { id: 0, value: 0 },
      ],
      [{ id: 1 }, { id: 2 }, { id: 0 }, { id: 0, value: 0 }, { id: 0, value: '1' }],
    ]
  } else {
    return [
      [
        { id: 0, value: 0 },
        { id: 2, value: 0 },
        { id: 2, value: 0 },
        { id: 0, value: units },
        { id: 0, value: 1 },
        { id: 1, value: currentDate },
        { id: 0, value: 0 },
        { id: 0, value: 0 },
      ],
      [
        { id: 0, value: 0 },
        { id: 0, value: 0 },
        { id: 2, value: 0 },
        { id: 0, value: units },
        { id: 0, value: 2 },
        { id: 2, value: 0 },
        { id: 0, value: 0 },
        { id: 0, value: 0 },
      ],
      [{ id: 1 }, { id: 2 }, { id: 0 }, { id: 0, value: 0 }, { id: 0, value: '1' }],
    ]
  }
}

export const customerNeverBought = (units, products, currentDate) => {
  const criteria = [
    [
      { id: 1, value: 0 },
      { id: 1, value: 0 },
      { id: 1, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: currentDate },
    ],
    [{ id: 1 }, { id: 2 }, { id: 0 }, { id: 0, value: 0 }, { id: 0, value: '1' }],
  ]
  if (!units?.length && !products?.length) {
    // Without units and without products
    criteria.push([
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 3, value: 0 },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ])
  } else if (units?.length && !products?.length) {
    // With units and without products
    criteria.push([
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ])
  } else {
    // With products
    criteria.push([
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: products },
      { id: 0, value: units },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ])
  }

  return criteria
}
export const totalClientsDecreasedAverageProductValue = (units, products, currentDate, minAmount) => [
  { id: 0, value: 0 },
  { id: 4, value: 0 },
  { id: 1, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: units },
  { id: 0, value: products },
  { id: 0, value: minAmount },
  { id: 0, value: 1 },
  { id: 1, value: currentDate },
]

export const totalClientsBelowAverageCoupons = (units, products, currentDate, minAmount) => [
  { id: 0, value: 0 },
  { id: 4, value: 0 },
  { id: 3, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: units },
  { id: 0, value: products },
  { id: 0, value: minAmount },
  { id: 0, value: 1 },
  { id: 1, value: currentDate },
]

export const didNotReceiveMessageOnChannelCriteria = (campaigns, channels, startDate, endDate) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 1, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: '2' },
    { id: 0, value: campaigns },
    { id: 0, value: channelsId },
    { id: 0, value: 1 },
    { id: 1, value: [startDate, endDate] },
  ]
}

export const becameLostInPeriodCriteria = (startDate, endDate) => {
  return [
    { id: 0, value: 0 },
    { id: 4, value: 0 },
    { id: 8, value: 0 },
    { id: 0, value: 3 },
    { id: 3, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: { type: 'fixed_range', value: [startDate, endDate] } },
  ]
}

export const becameLostBeforePeriodCriteria = (date) => {
  return [
    { id: 0, value: 0 },
    { id: 4, value: 0 },
    { id: 8, value: 0 },
    { id: 0, value: 3 },
    { id: 3, value: 1 },
    { id: 1, value: date },
  ]
}

export const campaignReceivedAndPurchasedAtUnitsOnFixedPeriodCriteria = (
  campaignIds,
  startDate,
  endDate,
  units = [],
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const campaignReceivedAndPurchasedAnyProductAtUnitsCriteria = (
  campaignIds,
  startDate,
  endDate,
  units = [],
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const campaignReceivedAndOnlyPurchasedAnyProductAtStoreCriteria = (
  campaignIds,
  startDate,
  endDate,
  units = [],
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels ? channels.map((channel) => channelToId[channel.toUpperCase()]) : []

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 3 },
      { id: 3, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const bougthAnyProductsAndWereActiveBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  aMonthAgoBeforeCampaignStarts,
  aDayBeforeCampaignStart,
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    version === 1
      ? [
          { id: 0, value: 0 },
          { id: 0, value: 0 },
          { id: 2, value: 0 },
          { id: 0, value: units },
          { id: 0, value: 1 },
          { id: 1, value: [aMonthAgoBeforeCampaignStarts, aDayBeforeCampaignStart] },
          { id: 0, value: 0 },
          { id: 0, value: 0 },
        ]
      : isActiveBeforeDate(startDate),
  ]
}

export const bougthAlsoCampaignProductsAndWereActiveBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  aMonthAgoBeforeCampaignStarts,
  aDayBeforeCampaignStart,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    version === 1
      ? [
          { id: 0, value: 0 },
          { id: 0, value: 0 },
          { id: 2, value: 0 },
          { id: 0, value: units },
          { id: 0, value: 1 },
          { id: 1, value: [aMonthAgoBeforeCampaignStarts, aDayBeforeCampaignStart] },
          { id: 0, value: 0 },
          { id: 0, value: 0 },
        ]
      : isActiveBeforeDate(startDate),
  ]
}

export const bougthOnlyCampaignProductsAndWereActiveBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  aMonthAgoBeforeCampaignStarts,
  aDayBeforeCampaignStart,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 3 },
      { id: 3, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    version === 1
      ? [
          { id: 0, value: 0 },
          { id: 0, value: 0 },
          { id: 2, value: 0 },
          { id: 0, value: units },
          { id: 0, value: 1 },
          { id: 1, value: [aMonthAgoBeforeCampaignStarts, aDayBeforeCampaignStart] },
          { id: 0, value: 0 },
          { id: 0, value: 0 },
        ]
      : isActiveBeforeDate(startDate),
  ]
}

export const bougthAnyProductsAndWereInactiveBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixtyDaysBefore,
  thirtyDaysBefore,
  oneDayBefore,
  aDayBeforeWithAMonthBefore,
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    ...(version === 1
      ? [
          [
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [thirtyDaysBefore, oneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
          [
            { id: 0, value: 0 },
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [sixtyDaysBefore, aDayBeforeWithAMonthBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
        ]
      : [isInactiveBeforeDate(startDate)]),
  ]
}

export const bougthAlsoCampaignProductsAndWereInactiveBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixtyDaysBefore,
  thirtyDaysBefore,
  oneDayBefore,
  aDayBeforeWithAMonthBefore,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    ...(version === 1
      ? [
          [
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [thirtyDaysBefore, oneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
          [
            { id: 0, value: 0 },
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [sixtyDaysBefore, aDayBeforeWithAMonthBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
        ]
      : [isInactiveBeforeDate(startDate)]),
  ]
}

export const bougthOnlyCampaignProductsAndWereInactiveBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixtyDaysBefore,
  thirtyDaysBefore,
  oneDayBefore,
  aDayBeforeWithAMonthBefore,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 3 },
      { id: 3, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    ...(version === 1
      ? [
          [
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [thirtyDaysBefore, oneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
          [
            { id: 0, value: 0 },
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [sixtyDaysBefore, aDayBeforeWithAMonthBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
        ]
      : [isInactiveBeforeDate(startDate)]),
  ]
}

export const bougthAnyProductsAndWereLostBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  twoMonthsBefore,
  twoMonthsAndOneDayBefore,
  oneDayBefore,
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    ...(version === 1
      ? [
          [
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [twoMonthsBefore, oneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
          [
            { id: 0, value: 0 },
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [sixMonthsBefore, twoMonthsAndOneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
        ]
      : [isLostBeforeDate(startDate)]),
  ]
}

export const bougthAlsoCampaignProductsAndWereLostBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  twoMonthsBefore,
  twoMonthsAndOneDayBefore,
  oneDayBefore,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    ...(version === 1
      ? [
          [
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [twoMonthsBefore, oneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
          [
            { id: 0, value: 0 },
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [sixMonthsBefore, twoMonthsAndOneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
        ]
      : [isLostBeforeDate(startDate)]),
  ]
}

export const bougthOnlyCampaignProductsAndWereLostBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  twoMonthsBefore,
  twoMonthsAndOneDayBefore,
  oneDayBefore,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 3 },
      { id: 3, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    ...(version === 1
      ? [
          [
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [twoMonthsBefore, oneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
          [
            { id: 0, value: 0 },
            { id: 0, value: 0 },
            { id: 2, value: 0 },
            { id: 0, value: units },
            { id: 0, value: 1 },
            { id: 1, value: [sixMonthsBefore, twoMonthsAndOneDayBefore] },
            { id: 0, value: 0 },
            { id: 0, value: 0 },
          ],
        ]
      : [isLostBeforeDate(startDate)]),
  ]
}

export const bougthAnyProductsAndNeverBoughtBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  oneDayBefore,
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    version === 1
      ? [
          { id: 0, value: 0 },
          { id: 2, value: 0 },
          { id: 2, value: 0 },
          { id: 0, value: units },
          { id: 0, value: 1 },
          { id: 1, value: [sixMonthsBefore, oneDayBefore] },
          { id: 0, value: 0 },
          { id: 0, value: 0 },
        ]
      : isNeverBoughtBeforeDate(startDate),
  ]
}

export const bougthAlsoCampaignProductsAndNeverBoughtBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  oneDayBefore,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    version === 1
      ? [
          { id: 0, value: 0 },
          { id: 2, value: 0 },
          { id: 2, value: 0 },
          { id: 0, value: units },
          { id: 0, value: 1 },
          { id: 1, value: [sixMonthsBefore, oneDayBefore] },
          { id: 0, value: 0 },
          { id: 0, value: 0 },
        ]
      : isNeverBoughtBeforeDate(startDate),
  ]
}

export const bougthOnlyCampaignProductsAndNeverBoughtBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  oneDayBefore,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 3 },
      { id: 3, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    version === 1
      ? [
          { id: 0, value: 0 },
          { id: 2, value: 0 },
          { id: 2, value: 0 },
          { id: 0, value: units },
          { id: 0, value: 1 },
          { id: 1, value: [sixMonthsBefore, oneDayBefore] },
          { id: 0, value: 0 },
          { id: 0, value: 0 },
        ]
      : isNeverBoughtBeforeDate(startDate),
  ]
}

export const bougthAnyProductsAndAtRiskBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  oneDayBefore,
  units = [],
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [...isAtRiskBeforeDate(startDate)],
  ]
}

export const bougthAlsoCampaignProductsAndAtRiskBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  oneDayBefore,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 2 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [...isAtRiskBeforeDate(startDate)],
  ]
}

export const bougthOnlyCampaignProductsAndAtRiskBeforeCampaignCriteria = (
  campaignIds,
  startDate,
  endDate,
  sixMonthsBefore,
  oneDayBefore,
  productIds = [],
  units = [],
  version = 1,
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 3 },
      { id: 3, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: productIds },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [...isAtRiskBeforeDate(startDate)],
  ]
}

export const campaignReceivedAndPurchasedOnFixedPeriodAtUnitsCriteria = (
  campaignIds,
  startDate,
  endDate,
  units = [],
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: campaignIds },
      { id: 0, value: channelsId },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const clientReceivedCampaignAndBougthTheProductCriteria = (campaignId, productId, channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: '2' },
    { id: 0, value: [campaignId] },
    { id: 0, value: channelsId },
    { id: 0, value: 2 },
    { id: 2, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: [productId] },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
  ]
}

export const clientReceivedCampaignAndBougthTheProductFirstTimeCriteria = (
  campaignId,
  startDate,
  endDate,
  sixMonthsBefore,
  aDayBeforeCampaignStart,
  productId,
  units = [],
  channels = ['SMS', 'PUSH', 'EMAIL', 'WHATSAPP']
) => {
  if (!channels) return []
  const channelToId = { SMS: 2, PUSH: 3, EMAIL: 5, WHATSAPP: 1 }
  const channelsId = channels.map((channel) => channelToId[channel.toUpperCase()])

  return [
    [
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: [campaignId] },
      { id: 0, value: channelsId },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: [productId] },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [sixMonthsBefore, aDayBeforeCampaignStart] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: [productId] },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [startDate, endDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

/* Price Range Quick Actions */

export const priceRangeClientsBougthAtRange = (periodStart, periodEnd, skusFromCurrentRange, units) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentRange },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const priceRangeClientsUpsellToRange = (
  referencePeriodStart,
  referencePeriodEnd,
  periodStart,
  periodEnd,
  skusFromCurrentRange,
  skusFromLowerRanges,
  skusFromCurrentAndUpperRanges,
  units
) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentRange },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromLowerRanges },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentAndUpperRanges },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const priceRangeClientsDownsellToRange = (
  referencePeriodStart,
  referencePeriodEnd,
  periodStart,
  periodEnd,
  skusFromCurrentRange,
  skusFromUpperRanges,
  skusFromCurrentAndLowerRanges,
  units
) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentRange },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromUpperRanges },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentAndLowerRanges },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const priceRangeClientBoughtProduct = (referencePeriodStart, referencePeriodEnd, productSku, units) => {
  return [
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: 0 },
    { id: 0, value: [productSku] },
    { id: 0, value: units },
    { id: 0, value: 1 },
    { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
  ]
}

export const priceRangeClientUpsellByProduct = (
  referencePeriodStart,
  referencePeriodEnd,
  periodStart,
  periodEnd,
  productSku,
  skusFromLowerRanges,
  skusFromCurrentAndUpperRanges,
  units
) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: [productSku] },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromLowerRanges },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentAndUpperRanges },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const priceRangeClientDownsellByProduct = (
  referencePeriodStart,
  referencePeriodEnd,
  periodStart,
  periodEnd,
  productSku,
  skusFromUpperRanges,
  skusFromCurrentAndLowerRanges,
  units
) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: [productSku] },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromUpperRanges },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentAndLowerRanges },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const priceRangeNewClientAtRange = (referencePeriodStart, referencePeriodEnd, periodStart, periodEnd, skusFromCurrentRange, allSkus, units) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentRange },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: allSkus },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const priceRangeLostClientAtRange = (referencePeriodStart, referencePeriodEnd, periodStart, periodEnd, skusFromCurrentRange, allSkus, units) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: skusFromCurrentRange },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: allSkus },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const priceRangeNewClientByProduct = (referencePeriodStart, referencePeriodEnd, periodStart, periodEnd, productSku, allSkus, units) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: [productSku] },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: allSkus },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const priceRangeLostClientByProduct = (referencePeriodStart, referencePeriodEnd, periodStart, periodEnd, productSku, allSkus, units) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: [productSku] },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [referencePeriodStart, referencePeriodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: allSkus },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1, value: [periodStart, periodEnd] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}
/* End Price Range Quick Actions */

export const clientsBoughtProductsOffersSchedule = (offerId, units, productsIds) => {
  return [
    [
      { id: 0 },
      { id: 5 },
      { id: 0 },
      { id: 0, value: offerId },
      { id: 0, value: units },
      { id: 0, value: 1 },
      { id: 1 },
      { id: 0 },
      { id: 0, value: productsIds },
      { id: 0 },
      { id: 0 },
    ],
  ]
}

export const boughtAdvertisedProductsOffersScheduleCriteria = (offerId, units) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 5, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: offerId },
      { id: 0, value: units },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const activatedProductsOffersScheduleCriteria = (offerId) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 5, value: 0 },
      { id: 1, value: 0 },
      { id: 0, value: offerId },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const activatedSpecificProductOffersScheduleCriteria = (offerId, productId) => {
  return [
    [
      { id: 0, value: 0 },
      { id: 5, value: 0 },
      { id: 1, value: 0 },
      { id: 0, value: offerId },
      { id: 0, value: 1 },
      { id: 1, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: productId },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]
}

export const purchasedCategoryOnUnitCriteria = (categoryId, dates, unitIds) => {
  return [
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 1, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: 0 },
    { id: 0, value: [categoryId] },
    { id: 0, value: unitIds.map((unitId) => ({ dataType: ['ECOMMERCE', 'PHYSICAL'], value: unitId })) },
    { id: 0, value: 1 },
    { id: 1, value: dates },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
  ]
}

export const didNotPurchaseCategoryOnUnitCriteria = (categoryId, dates, unitIds) => {
  return [
    { id: 0, value: 0 },
    { id: 2, value: 0 },
    { id: 1, value: 0 },
    { id: 0, value: 1 },
    { id: 1, value: 0 },
    { id: 0, value: [categoryId] },
    { id: 0, value: unitIds.map((unitId) => ({ dataType: ['ECOMMERCE', 'PHYSICAL'], value: unitId })) },
    { id: 0, value: 1 },
    { id: 1, value: dates },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
  ]
}
export const redeemedCouponsCriteria = (statusId, couponId, dynamicPeriod, dates) => {
  return [
    {
      id: 2,
      value: 0,
    }, // categoria "canais"
    {
      id: 5,
      value: 0,
    }, // seção "benefícios"
    {
      id: 2,
      value: 0,
    }, // Segmento "consumiu cupom de desconto"
    /*
      ativou = id:1
      resgatou = id:2
     */
    {
      id: 0,
      value: statusId,
    },
    {
      id: statusId,
      value: 0,
    },
    {
      id: 0,
      value: couponId,
    }, // ID do benefício
    {
      id: 0,
      value: dates.length > 0 ? 1 : dynamicPeriod,
    }, // período dinâmico (value: 0) ou fixo (value: 1)
    {
      id: 1,
      value: dates,
    }, // caso seja período fixo (id: 1), caso contrário (id: 0)
  ]
}
export const consumedCouponsCriteria = (couponId, unitsConfiguration, skus, dynamicPeriod, dates, hasProducts) => {
  return [
    { id: 2, value: 0 },
    { id: 5, value: 0 },
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: couponId },
    { id: 0, value: unitsConfiguration },
    { id: 0, value: hasProducts ? (skus.length ? 1 : 0) : 0 },
    ...(hasProducts
      ? [
          {
            id: 1,
            value: skus.length ? 2 : 0,
          },
        ]
      : []),
    { id: hasProducts ? (skus.length ? 2 : 0) : 0, value: 0 },
    { id: 0, value: hasProducts ? skus : 0 },
    { id: 0, value: dates.length > 0 ? 1 : dynamicPeriod },
    { id: 1, value: dates },
  ]
}

export const totalConsumedCouponsCriteria = (couponId, unitsConfiguration, skus, dates) => {
  return [
    { id: 2, value: 0 },
    { id: 5, value: 0 },
    { id: 2, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: couponId },
    { id: 0, value: unitsConfiguration },
    { id: 0, value: 1 },
    { id: 1, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: skus },
    { id: 0, value: 1 },
    { id: 1, value: dates },
  ]
}

export const rfvClientsGroupCriteria = (rfvConfigurationId, rfvPeriodId, clientTypes) => {
  return [
    { id: 0, value: 0 },
    { id: 6, value: 0 },
    { id: 0, value: 0 },
    { id: 0, value: [rfvConfigurationId] },
    { id: 0, value: [rfvPeriodId] },
    { id: 0, value: clientTypes },
  ]
}

/* DRE - Inicio */

export const dreChannelsDistributionCriteria = (configurationId, periodId, period, channel) => {
  const channels = {
    sms: [
      { id: 2, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    push: [
      { id: 2, value: 0 },
      { id: 2, value: 0 },
      { id: 1, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    whatsapp: [
      { id: 2, value: 0 },
      { id: 2, value: 0 },
      { id: 3, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    email: [
      { id: 2, value: 0 },
      { id: 2, value: 0 },
      { id: 2, value: 0 },
      { id: 0, value: 5 },
      { id: 5, value: 0 },
    ],
    notReceived: [
      { id: 2, value: 0 },
      { id: 6, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: '2' },
      { id: 0, value: [2, 5, 3, 1] },
    ],
  }

  return [
    [
      { id: 0, value: 0 },
      { id: 7, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: [configurationId] },
      { id: 0, value: [periodId] },
      { id: 0, value: ['active', 'first_buy', 'inactive', 'lost'] },
    ],
    [...channels[channel], { id: 0, value: 1 }, { id: 1, value: period }],
  ]
}

const dreCriteria = (configurationId, analysedPeriodId) => [
  { id: 0, value: 0 },
  { id: 7, value: 0 },
  { id: 0, value: 0 },
  { id: 0, value: [configurationId] },
  { id: 0, value: [analysedPeriodId] },
  { id: 0, value: ['active', 'first_buy', 'inactive', 'lost'] },
]

export const getFidelityBoughtFilter = (isDre) => {
  return isDre
    ? [
        { id: 0, value: 0 },
        { id: 0, value: 0 },
      ]
    : [
        { id: 0, value: 2 },
        { id: 2, value: 0 },
      ]
}

export const activesConsumersDistributionCriteria = (isDre, configurationId, analysedPeriodId, { boughtDate }, analysisInitialDate) => {
  const fidelityFilter = getFidelityBoughtFilter(isDre)

  const activesCriteria = [
    { id: 0, value: 0 },
    { id: 0, value: 0 },
    { id: 3, value: 0 },
    ...fidelityFilter,
    { id: 0, value: 1 },
    { id: 1, value: [boughtDate.initialDate, boughtDate.finalDate] },
    { id: 0, value: 0 },
    { id: 0, value: 0 },
  ]

  return isDre ? [dreCriteria(configurationId, analysedPeriodId), activesCriteria] : [activesCriteria, signUpClubCriteria(analysisInitialDate)]
}

export const inactivesConsumersDistributionCriteria = (isDre, configurationId, analysedPeriodId, { boughtDate, notBoughtDate }, analysisInitialDate) => {
  const fidelityFilter = getFidelityBoughtFilter(isDre)

  const inactivesCriteria = [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 3, value: 0 },
      ...fidelityFilter,
      { id: 0, value: 1 },
      { id: 1, value: [boughtDate?.initialDate, boughtDate?.finalDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 3, value: 0 },
      ...fidelityFilter,
      { id: 0, value: 1 },
      { id: 1, value: [notBoughtDate?.initialDate, notBoughtDate?.finalDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]

  return isDre ? [dreCriteria(configurationId, analysedPeriodId), ...inactivesCriteria] : [...inactivesCriteria, signUpClubCriteria(analysisInitialDate)]
}

export const atRiskConsumersDistributionCriteria = (isDre, configurationId, analysedPeriodId, { boughtDate, notBoughtDate }, analysisInitialDate) => {
  const fidelityFilter = getFidelityBoughtFilter(isDre)

  const atRiskCriteria = [
    [
      { id: 0, value: 0 },
      { id: 0, value: 0 },
      { id: 3, value: 0 },
      ...fidelityFilter,
      { id: 0, value: 1 },
      { id: 1, value: [boughtDate?.initialDate, boughtDate?.finalDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 3, value: 0 },
      ...fidelityFilter,
      { id: 0, value: 1 },
      { id: 1, value: [notBoughtDate?.initialDate, notBoughtDate?.finalDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]

  return isDre ? [dreCriteria(configurationId, analysedPeriodId), ...atRiskCriteria] : [...atRiskCriteria, signUpClubCriteria(analysisInitialDate)]
}

export const lossesConsumersDistributionCriteria = (isDre, configurationId, analysedPeriodId, { boughtDate, notBoughtDate }, analysisInitialDate) => {
  const fidelityFilter = getFidelityBoughtFilter(isDre)

  const lossesCriteria = [
    [{ id: 0, value: 0 }, { id: 0, value: 0 }, { id: 3, value: 0 }, ...fidelityFilter, { id: 0, value: 3 }, { id: 3, value: notBoughtDate?.initialDate }],
    [
      { id: 0, value: 0 },
      { id: 2, value: 0 },
      { id: 3, value: 0 },
      ...fidelityFilter,
      { id: 0, value: 1 },
      { id: 1, value: [notBoughtDate?.initialDate, notBoughtDate?.finalDate] },
      { id: 0, value: 0 },
      { id: 0, value: 0 },
    ],
  ]

  return isDre ? [dreCriteria(configurationId, analysedPeriodId), ...lossesCriteria] : [...lossesCriteria, signUpClubCriteria(analysisInitialDate)]
}

export const signUpClubCriteria = (date) => {
  return [
    { id: 1, value: 0 },
    { id: 1, value: 0 },
    { id: 1, value: 0 },
    { id: 0, value: 3 },
    { id: 3, value: date },
  ]
}

export const neverBoughtConsumersDistributionCriteria = (isDre, configurationId, analysedPeriodId, analysisInitialDate) => {
  const fidelityFilter = getFidelityBoughtFilter(isDre)

  const neverBoughtCriteria = [
    { id: 0, value: 0 },
    { id: 2, value: 0 },
    { id: 3, value: 0 },
    ...fidelityFilter,
    { id: 0, value: 3 },
    { id: 3, value: analysisInitialDate },
  ]
  return isDre ? [dreCriteria(configurationId, analysedPeriodId), neverBoughtCriteria] : [neverBoughtCriteria, signUpClubCriteria(analysisInitialDate)]
}
export const dreIncrementalRevenueDetailsCriteria = (configurationId, drePeriodId, index) => {
  const clients = {
    0: ['active'],
    1: ['inactive'],
    2: ['lost'],
    3: ['first_buy'],
    4: ['active', 'inactive', 'lost', 'first_buy'],
  }

  return [
    [
      { id: 0, value: 0 },
      { id: 7, value: 0 },
      { id: 0, value: 0 },
      { id: 0, value: [configurationId] },
      { id: 0, value: [drePeriodId] },
      { id: 0, value: clients[index] },
    ],
  ]
}

/* DRE - Fim */
